export default __webpack_public_path__ + "static/SCGJ-1d98f6c7b96db44d88fa6ecaee284b50.jpg";